import { LoadableLazy } from '@confluence/loadable';

export const AISummaryFooter = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AISummaryFooter" */ '../src/shared-components/AISummaryFooter'
			)
		).AISummaryFooter,
});
